import { callZpayFunction } from '../../callZpayFunction';

// 장바구니 삭제
export const deleteCart = () => {
  callZpayFunction('deleteCart')();
};
